module.exports = __webpack_public_path__ + "img/customer-a-047.84578fd4.png";